import React from "react";
import { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import { CachePersistor } from "apollo3-cache-persist";

export interface ApolloClientContextType {
  client: ApolloClient<NormalizedCacheObject> | null;
  persistor: CachePersistor<NormalizedCacheObject> | null;
  clearCache: () => Promise<void>;
}

const defaultApolloClientContext: ApolloClientContextType = {
  client: null,
  persistor: null,
  clearCache: async () => {}, // no-op Promise<void>
};

const ApolloClientContext = React.createContext<ApolloClientContextType>(
  defaultApolloClientContext,
);

export default ApolloClientContext;
